import { LoadingSpinner } from './LoadingSpinner';

export const FullScreenLoadingSpinner = () => {
  return (
    <div className='flex h-full w-full items-center justify-center'>
      <LoadingSpinner width={100} />
    </div>
  );
};
